import React from 'react'
import { View, StyleSheet } from 'react-native'
import { Text } from '@libs/components'

const obfuscateEmail = (email) => {
  if (!email) return ''
  const [local, domain] = email.split('@')
  if (!local || !domain) return email
  const firstChar = local.charAt(0)
  const obfuscatedLocal = firstChar + '*'.repeat(local.length - 1)
  return `${obfuscatedLocal}@${domain}`
}

const CheckEmail = ({ route, email, title = 'Registration', hours = 24 }) => {
  const {
    email: emailForgotPassword,
    title: titleForgotPassword,
    hours: hoursForgotPassword,
  } = route.params || {}

  return (
    <View style={styles.outerContainer}>
      <View style={styles.container}>
        <Text style={styles.heading} variant="heading2">
          {titleForgotPassword || title}
        </Text>
        {route.params ? (
          <Text style={styles.bodyText}>
            We've sent a password reset link to{' '}
            <Text style={styles.email}>
              {obfuscateEmail(emailForgotPassword)}
            </Text>
            . Please click the link in the email to set a new password. For your
            security, the link will expire in {hoursForgotPassword * 60}{' '}
            minutes.
          </Text>
        ) : (
          <>
            <Text style={styles.bodyText}>
              We've sent a verification email to{' '}
              <Text style={styles.email}>{email}</Text>. Please click the
              verification link inside to complete your registration. For your
              security, the link will expire in 24 hours.
            </Text>
            <Text style={[styles.bodyText, { marginTop: 10 }]}>
              Can't see the email? Be sure to check your spam or junk folder.
            </Text>
          </>
        )}
      </View>
    </View>
  )
}

const styles = StyleSheet.create({
  outerContainer: {
    flex: 1,
    justifyContent: 'center',
    marginTop: '20%',
    paddingHorizontal: 24,
    width: '100%',
    flexDirection: 'row',
  },
  container: {
    width: '100%',
    maxWidth: 500,
  },
  heading: {
    // fontSize: 35,
    marginBottom: 20,
    textAlign: 'center',
    fontWeight: 700,
  },
  bodyText: {
    fontSize: 16,
    color: '#64748B',
    // textAlign: 'center',
    lineHeight: 28,
  },
  email: {
    fontWeight: 'bold',
    color: '#2563eb',
    fontSize: 16,
  },
})

export default CheckEmail
